import { render, staticRenderFns } from "./docLayout.vue?vue&type=template&id=a1ffe88e&scoped=true&"
import script from "./docLayout.vue?vue&type=script&lang=js&"
export * from "./docLayout.vue?vue&type=script&lang=js&"
import style0 from "./docLayout.vue?vue&type=style&index=0&id=a1ffe88e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ffe88e",
  null
  
)

export default component.exports